module.exports = __webpack_public_path__ + "img/yijian_gaoji.6669b1c4.png";